import type { TableHeadProps as MuiTableHeadProps } from '@mui/material';
import { TableHead as MuiTableHead } from '@mui/material';

/**
 * <p>
 * Based on MUI TableHead: https://mui.com/material-ui/api/table-head/
 * </p>
 * */
export const TableHead = (props: MuiTableHeadProps) => <MuiTableHead {...props} />;
